"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    OverlayFooter: ()=>OverlayFooter,
    PrimaryActionButton: ()=>PrimaryActionButton,
    SecondaryActionButton: ()=>SecondaryActionButton
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_OverlayFooter_variants_cjs_namespaceObject = require("./OverlayFooter.variants.cjs");
const index_cjs_namespaceObject = require("../Button/index.cjs");
const external_utils_index_cjs_namespaceObject = require("../../utils/index.cjs");
const PrimaryActionButton = ({ onClick, children })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Button, {
        type: "primary",
        buttonType: "button",
        onClick: onClick,
        size: "sm",
        children: children
    });
const SecondaryActionButton = ({ onClick, children })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Button, {
        type: "secondary",
        buttonType: "button",
        onClick: onClick,
        size: "sm",
        children: children
    });
const OverlayFooter = ({ primaryAction, secondaryAction, footerContent, className, ...props })=>{
    const { footerSlot, actionsSlot, customNodeSlot } = (0, external_OverlayFooter_variants_cjs_namespaceObject.overlayFooterVariants)({
        ...props
    });
    const footerSlotClasses = (0, external_utils_index_cjs_namespaceObject.cn)(footerSlot(), className);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: "@container",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
            className: footerSlotClasses,
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: customNodeSlot(),
                    children: footerContent
                }),
                (secondaryAction || primaryAction) && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: actionsSlot(),
                    children: [
                        secondaryAction,
                        primaryAction
                    ]
                })
            ]
        })
    });
};
exports.OverlayFooter = __webpack_exports__.OverlayFooter;
exports.PrimaryActionButton = __webpack_exports__.PrimaryActionButton;
exports.SecondaryActionButton = __webpack_exports__.SecondaryActionButton;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "OverlayFooter",
    "PrimaryActionButton",
    "SecondaryActionButton"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
